import React, { useState} from 'react'
import { translate, titleConvert } from '../../assets/js/functions';
import { domain } from "../../assets/js/api";
import { Link } from 'react-router-dom'
import IcoGallery from "../../assets/img/ico-galeria.svg";
import IcoTornar from "../../assets/img/ico-enrere.svg";
import parse from 'html-react-parser';

import IcoNext from "../../assets/img/ico-anterior.svg"
import IcoPrev from "../../assets/img/ico-seguent.svg"

import 'react-responsive-modal/styles.css';
import Modal from "react-responsive-modal";


/*

            classNames={{
                root: 'lightbox',
                modalContainer: 'is-flex is-flex-direction-column is-justify-content-center is-align-items-center p-5 h-100',
                modal: 'lightbox__container p-5 has-background-white w-100',
            }}


*/


export default function ViewGallery({group, gallery}) {
    const [galleryElem, setGalleryElem] = useState(null);
    const [open, setOpen] = useState(false);


    function toggleModal() {
        setOpen(false);
        setGalleryElem(null);
    }

    function prevImg() {
        let index = galleryElem - 1;
        if (index < 0) {
            index = gallery.length - 1;
        }
        setGalleryElem(index);
    }

    function nextImg() {
        let index = galleryElem + 1;
        if (index >= gallery.length) {
            index = 0;
        }
        setGalleryElem(index);
    }

    return (
        <>
        {(gallery && gallery.length > 0)?
            <>
            <h2>{translate('Galeria d\'imatges')}</h2>
            <div className="gallery is-flex is-flex-wrap-wrap gap-2">
                {gallery.map((image, index) =>
                <Link key={index} to="" onClick={(event) => {
                    event.preventDefault();
                    setOpen(true);
                    setGalleryElem(index);
                    }} className="is-flex">
                    <img loading="lazy" src={domain+image.image} width="157" height="105" alt=""/>
                </Link>
                )}

                <Link to="" onClick={(event) => {
                    event.preventDefault();
                    setOpen(true);
                    }} className="gallery__last is-flex is-flex-direction-column is-justify-content-center is-flex-grow-1 is-align-items-center gap-1 p-4 is-family-secondary is-size-7 has-text-black is-lowercase link-dn">
                    <img loading="lazy" src={IcoGallery} alt="" width="29" height="23"/>
                    {translate('Veure galeria completa')}
                </Link>
            </div>
            <Modal
            open={open}
            onClose={toggleModal}
            showCloseIcon={false}
            >
                {galleryElem !== null?
                <>
                <div className="is-flex is-justify-content-space-between is-align-items-center mb-8">
                    <button onClick={(event) => {event.preventDefault();setGalleryElem(null)}} type="button" className="button is-text p-0">
                        <img loading="lazy" src={IcoTornar} alt={translate('Tornar a la galeria')} width="48" height="34"/>
                    </button>
                    <button onClick={(event) => {event.preventDefault();toggleModal()}} type="button" className="button button--icon button--tancar">
                        <span>{translate('Tancar galeria completa')}</span>
                    </button>
                </div>
                <div className="wrapper is-paddingless">
                    <div className="columns is-desktop is-variable is-8">
                        <div className="column is-two-thirds-desktop">
                            <img src={domain+gallery[galleryElem].image} alt="" width="1140" height="760"/>
                            <div className="is-flex is-align-items-center is-justify-content-space-between gap-3 mt-5">
                                <button onClick={(event) => {event.preventDefault();prevImg()}} type="button" className="button is-text p-0 is-flex-shrink-0">
                                    <img loading="lazy" src={IcoNext} alt={translate('Anterior')} width="59" height="42"/>
                                </button>
                                <button onClick={(event) => {event.preventDefault();nextImg()}} type="button" className="button is-text p-0 is-flex-shrink-0">
                                    <img loading="lazy" src={IcoPrev} alt={translate('Següent')} width="59" height="42"/>
                                </button>
                            </div>
                        </div>
                        <div className="column flow flow--larger">
                            <h1 className="is-size-8 mt-5">{parse(gallery[galleryElem].footprint)}</h1>
                            <p>{parse(gallery[galleryElem].description)}</p>
                        </div>
                    </div>
                </div>
                </>
                :
                <>
                <div className="is-flex">
                    <button onClick={(event) => {event.preventDefault();toggleModal()}} type="button" className="button button--icon button--tancar">
                        <span>{translate('Tancar galeria completa')}</span>
                    </button>
                </div>
                <div className="wrapper">
                    <h1 className="has-text-centered is-lowercase is-family-secondary is-size-1 mb-7">
                        <svg className="is-block mx-auto mb-3" width="29" height="23" xmlns="http://www.w3.org/2000/svg">
                            <g stroke="#000" strokeWidth="3" fill="none" fillRule="evenodd" strokeLinecap="round">
                                <path d="M27 7.77a1.923 1.923 0 0 0-1.923-1.924H21.23L18.346 2h-7.692L7.769 5.846H3.923A1.923 1.923 0 0 0 2 7.77v11.539a1.923 1.923 0 0 0 1.923 1.923h21.154A1.923 1.923 0 0 0 27 19.308V7.769Z" />
                                <path d="M14.5 16.904a4.327 4.327 0 1 0 0-8.654 4.327 4.327 0 0 0 0 8.654Z" />
                            </g>
                        </svg>
                        {translate('Cuidar')} {titleConvert(group)}
                    </h1>
                    <div className="columns is-multiline is-justify-content-center mb-7">
                        {gallery.map((image, index) =>
                        <div key={index} className="column is-narrow">
                            <Link to="" onClick={(event) => {
                                event.preventDefault();
                                setGalleryElem(index);
                                }} className="is-flex">
                                <img loading="lazy" src={domain+image.image} width="312" height="208" className="is-flex" alt=""/>
                            </Link>
                        </div>
                        )}
                    </div>
                </div>
                </>
                }
            </Modal>
            </>
        :''}
        </>
    )
}
